import logo from './logo.svg';
import './App.css';
import TodoList from './Todolist';

function App() {
  return (
    <div>
  <TodoList/>
    </div>
  );
}

export default App;
